<template>
  <div class="pc-shell">
    <!-- 顶部导航栏 -->
    <header class="pc-header">
      <div class="pc-header__inner">
        <div class="pc-header__brand">
          <img
            class="pc-header__logo-icon"
            :src="require('@/assets/img/platelistIcon.png')"
            alt=""
          />
          <span class="pc-header__brand-name">一尘盯盘</span>
        </div>

        <nav class="pc-header__nav">
          <div
            v-for="item in navList"
            :key="item.path"
            class="pc-header__nav-item"
            :class="{ 'pc-header__nav-item--active': isActive(item.path) }"
            @click="goPath(item.path)"
          >
            <van-icon class="pc-header__nav-icon" :name="item.icon" />
            <span>{{ item.label }}</span>
          </div>
        </nav>

        <div class="pc-header__user">
          <div class="pc-header__user-name">{{ displayName }}</div>
          <div class="pc-header__user-vips">
            <div class="pc-vip-row">
              <span class="pc-vip-label">盯盘</span>
              <span class="pc-vip-tag" :class="isVip1 ? 'pc-vip-tag--active' : 'pc-vip-tag--off'">
                {{ isVip1 ? formatExpire(vipExpireTime) : '未开通' }}
              </span>
            </div>
            <div class="pc-vip-row">
              <span class="pc-vip-label">发帖</span>
              <span class="pc-vip-tag" :class="isVip3 ? 'pc-vip-tag--active' : 'pc-vip-tag--off'">
                {{ isVip3 ? formatExpire(createPostExpireTime) : '未开通' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>

    <!-- 内容区域 -->
    <main class="pc-main">
      <div class="pc-content" :class="{ 'pc-content--full': hideSidebar }">
        <!-- 返回栏（hideSidebar 模式，如版块列表） -->
        <div v-if="hideSidebar" class="pc-subheader">
          <div class="pc-subheader__back" @click="goBack">
            <van-icon name="arrow-left" />
            <span>返回</span>
          </div>
          <div class="pc-subheader__title">{{ title }}</div>
          <div class="pc-subheader__spacer"></div>
        </div>

        <!-- 页面标题区（普通模式） -->
        <div v-if="!hideSidebar && (title || description)" class="pc-page-header">
          <div class="pc-page-header__title">{{ title }}</div>
          <div v-if="description" class="pc-page-header__desc">{{ description }}</div>
        </div>

        <!-- 内容卡片 -->
        <div class="pc-card">
          <slot />
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { pcNavList } from './utils';

export default {
  name: 'PcBaseShell',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    wide: {
      type: Boolean,
      default: true,
    },
    hideSidebar: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    navList() {
      return pcNavList;
    },
    displayName() {
      const storeUser = this.$store.state.app.userinfos || {};
      const cacheUser = JSON.parse(window.localStorage.getItem('userInfo') || '{}');
      return storeUser.nickName || cacheUser.nickName || '未登录用户';
    },
    isVip1() {
      const u = this.$store.state.app.userinfos || {};
      return u.isVip == 1 && u.vipExpireTime;
    },
    isVip3() {
      const u = this.$store.state.app.userinfos || {};
      return u.createPostIsVip == 1 && u.createPostExpireTime;
    },
    vipExpireTime() {
      return (this.$store.state.app.userinfos || {}).vipExpireTime;
    },
    createPostExpireTime() {
      return (this.$store.state.app.userinfos || {}).createPostExpireTime;
    },
  },
  methods: {
    formatExpire(date) {
      if (!date) return '';
      const d = new Date(date);
      if (isNaN(d.getTime())) return '';
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}/${m}/${day}`;
    },
    isActive(path) {
      return this.$route.path === path || this.$route.path.startsWith(path + '/');
    },
    goPath(path) {
      if (this.$route.path === path) return;
      this.$router.push(path);
    },
    goBack() {
      window.history.back();
    },
  },
};
</script>

<style lang="less" scoped>
// ── 全局背景 ────────────────────────────────────────────
.pc-shell {
  min-height: 100vh;
  background: linear-gradient(180deg, #f0f5fa 0%, #eaf1f6 100%);
}

// ── 顶部导航栏 ──────────────────────────────────────────
.pc-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: linear-gradient(0deg, rgba(255, 241, 235, 0.95) 0%, rgba(172, 224, 249, 0.95) 100%);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(20, 58, 93, 0.07);
  box-shadow: 0 2px 16px rgba(29, 67, 108, 0.06);
}

.pc-header__inner {
  display: flex;
  align-items: center;
  gap: 0;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
  height: 56px;
}

// ── 品牌区 ──────────────────────────────────────────────
.pc-header__brand {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 32px;
  flex-shrink: 0;
}

.pc-header__logo-icon {
  width: 20px;
  height: 20px;
}

.pc-header__brand-name {
  font-size: 16px;
  font-weight: 700;
  color: #16314b;
  white-space: nowrap;
}

// ── 导航区 ──────────────────────────────────────────────
.pc-header__nav {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
}

.pc-header__nav-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #2a82e4;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: rgba(42, 130, 228, 0.1);
    color: #16314b;
  }
}

.pc-header__nav-item--active {
  background: rgba(42, 130, 228, 0.14);
  color: #16314b;
  font-weight: 600;
  text-decoration: none;
}

.pc-header__nav-icon {
  font-size: 15px;
}

// ── 用户区 ──────────────────────────────────────────────
.pc-header__user {
  flex-shrink: 0;
  margin-left: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.pc-header__user-name {
  font-size: 13px;
  font-weight: 600;
  color: #16314b;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pc-header__user-vips {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.pc-vip-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pc-vip-label {
  font-size: 11px;
  color: #8da2b8;
  width: 24px;
  flex-shrink: 0;
}

.pc-vip-tag {
  font-size: 11px;
  font-weight: 500;
  padding: 1px 6px;
  border-radius: 4px;
  white-space: nowrap;
}

.pc-vip-tag--active {
  color: #c9942a;
  background: rgba(201, 148, 42, 0.1);
}

.pc-vip-tag--off {
  color: #a0b0c0;
  background: rgba(160, 176, 192, 0.1);
}

// ── 内容主区域 ──────────────────────────────────────────
.pc-main {
  padding: 20px 24px 40px;
}

.pc-content {
  max-width: 960px;
  min-width: 960px;
  margin: 0 auto;
}

.pc-content--full {
  max-width: 1280px;
  min-width: 960px;
}

// ── 返回子页头（hideSidebar 模式）──────────────────────
.pc-subheader {
  position: sticky;
  top: 56px;
  z-index: 99;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 20px;
  margin-bottom: 16px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(20, 58, 93, 0.07);
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(29, 67, 108, 0.05);
  backdrop-filter: blur(8px);
}

.pc-subheader__back {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #2a82e4;
  cursor: pointer;
  padding: 5px 12px;
  border-radius: 8px;
  flex-shrink: 0;
  transition: background 0.15s;

  &:hover {
    background: rgba(42, 130, 228, 0.08);
  }
}

.pc-subheader__title {
  font-size: 16px;
  font-weight: 700;
  color: #16314b;
}

.pc-subheader__spacer {
  flex: 1;
}

// ── 页面标题区（普通模式）──────────────────────────────
.pc-page-header {
  padding: 16px 20px 14px;
  margin-bottom: 16px;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(20, 58, 93, 0.07);
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(29, 67, 108, 0.05);
}

.pc-page-header__title {
  font-size: 22px;
  font-weight: 700;
  color: #16314b;
  line-height: 1.3;
}

.pc-page-header__desc {
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.7;
  color: #70859b;
}

// ── 内容卡片 ────────────────────────────────────────────
.pc-card {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(20, 58, 93, 0.07);
  border-radius: 20px;
  box-shadow: 0 4px 24px rgba(29, 67, 108, 0.07);
  // 不使用 backdrop-filter，否则会为 position:fixed 子孙创建新的包含块，
  // 导致 van-popup 等固定弹窗被 overflow:hidden 裁剪而无法显示。
  overflow: hidden;
}

// ── iPad 响应式（768px - 1024px）────────────────────────
@media screen and (max-width: 1024px) {
  .pc-header__inner {
    padding: 0 16px;
    height: 52px;
  }

  .pc-subheader {
    top: 52px;
  }

  .pc-header__brand {
    margin-right: 20px;
  }

  .pc-header__nav-item {
    padding: 6px 12px;
    font-size: 13px;
  }

  .pc-main {
    padding: 16px 16px 32px;
  }

  .pc-content {
    max-width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .pc-header {
    display: none;
  }

  .pc-shell {
    background: none;
    min-height: unset;
  }

  .pc-main {
    padding: 0;
  }

  .pc-content {
    min-width: unset;
    max-width: unset;
  }

  .pc-page-header,
  .pc-subheader {
    display: none;
  }

  .pc-card {
    background: none;
    border: none;
    border-radius: 0;
    box-shadow: none;
    backdrop-filter: none;
  }
}
</style>
